// src/context/AuthContext.ts
import { createContext } from 'react';

// Обновленный тип для пользователя
export interface User {
    username: string;
    role: 'user' | 'admin';
    isBlocked: boolean; // Добавляем поле для статуса блокировки
}

// Определяем тип для AuthContext
export interface AuthContextType {
    token: string | null;
    user: User | null;
    allUsers: User[]; // Добавляем список всех пользователей
    login: (newToken: string, username: string, role: 'user' | 'admin') => void;
    logout: () => void;
    // Новые функции для управления пользователями (будут реализованы в App.tsx)
    registerUser: (username: string, role: 'user' | 'admin') => { success: boolean, message: string };
    updateUserStatus: (username: string, isBlocked: boolean) => void;
    deleteUser: (username: string) => void;
    getUserBasicLists: (username: string) => any; // Функция для получения списков конкретного пользователя
}

// Создаем контекст с начальным значением undefined.
// Позже мы обернем наше приложение в AuthContext.Provider,
// чтобы предоставить фактические значения.
export const AuthContext = createContext<AuthContextType | undefined>(undefined);